/**
 * The words for a refused send for approval, in ONE place.
 *
 * Jake, 2026-11-04: no approval request (and no approval) for embroidery
 * whose stitch file is not in yet. The API refuses with the stable code
 * `design_not_digitized` (`approval_digitization.DESIGN_NOT_DIGITIZED_CODE`):
 * a 409 `{error, code}` on Send for approval, a `not_digitized` row per held
 * size when other sizes went, and a `skipped` reason on the batch send. This
 * map is the only place that turns the code into words; an unknown code
 * returns null so the caller keeps its own fallback.
 *
 * Awaiting Jake's copy review
 * (~/Desktop/Temp/approval-digitized-copy-review-2026-11-04.md).
 */

export const DESIGN_NOT_DIGITIZED = "design_not_digitized";

export const APPROVAL_SEND_SENTENCES = Object.freeze({
  [DESIGN_NOT_DIGITIZED]:
    "This embroidery design is not digitized yet, so it was not sent for " +
    "approval. Send it once the digitized file is back.",
});

/** The sentence for a refusal code, or null for a code this map does not know. */
export function approvalSendSentence(code) {
  return Object.hasOwn(APPROVAL_SEND_SENTENCES, code)
    ? APPROVAL_SEND_SENTENCES[code]
    : null;
}

/** The toast line for N sizes held back from an otherwise-sent design. */
export function notDigitizedSizesSentence(count) {
  const n = Number(count) || 0;
  if (n <= 0) return "";
  return n === 1
    ? "1 embroidery size was not sent: it is not digitized yet."
    : `${n} embroidery sizes were not sent: they are not digitized yet.`;
}

/** The batch result fragment that follows the artwork's name. */
export const BATCH_NOT_DIGITIZED_TEXT =
  "was not sent for approval: its embroidery is not digitized yet. Send it " +
  "for approval once the digitized file is back";
